
import { useState } from 'react';

export const useViewMode = () => {
  const [viewMode, setViewMode] = useState<'list' | 'map'>('list');
  
  return {
    viewMode,
    setViewMode,
  };
};
